import { Component, EventEmitter, Output, Input} from '@angular/core';
import { AgendaModelV3, AgendaEvent, QueovalDateTime, SelectedEvent, AgendaRow, AgendaCol, Calendar } from '../../../models';
import { QueovalDateService, CoreService, HttpService } from '../../../services';
import { ToastService } from '../../../toast';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-affiche-week-v3',
  templateUrl: './affiche.week.component.html',
  styleUrls: ['./affiche.week.component.css', '../affiche.component.css']
})
// Affiche la grille du calendrier
export class AfficheWeekComponentV3 {

  public boolDataNeedToBeUpdated: boolean;
  public dragMode: string;
  public hoverDivMode: string;
  public dragStart: boolean = false;
  public dragColId: number;
  public dragRowId: number;
  public contextEvent: AgendaEvent | null;

  private elementDragged: AgendaEvent;
  private boolShowDailyEvent: boolean = false;
  private isUpdate: boolean = false;

  @Input() model: AgendaModelV3;
  @Output('modelChange') modelChange: EventEmitter<AgendaModelV3> = new EventEmitter<AgendaModelV3>(true);

  @Input('refreshData')
  set OnRefreshData(value: boolean) {
    this.SetBeginAgenda(value);
  }
  @Output('refreshDataChange') refreshDataChange: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  @Output('openEvent') openEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>(true);
  @Output('newEvent') newEvent: EventEmitter<QueovalDateTime> = new EventEmitter<QueovalDateTime>(true);
  @Output('updateEvent') updateEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>(true);
  @Output('loading') loading: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  constructor(
    private http: HttpService,
    protected toastService: ToastService,
    public indParam: CoreService,
    protected qdate: QueovalDateService
  ) { }

  public CompareDates(i: number): boolean {
    return this.qdate.Compare(this.qdate.Now(), '=', this.model.listCalendars[0].body.startDate, i, 'days');
  }

  // toogle la liste des événements dans la partie suppérieure de l'agenda
  public ShowHideDailyEvents(): void {
    this.isUpdate = true;
    const maxContainerSize: number = 69 + (this.model.listCalendars[0].body.weeklyRows[0].maxEvents * 24);
    const container: HTMLElement = document.getElementsByClassName('agenda-header')[0] as HTMLElement;
    const calendar: HTMLElement = document.getElementsByClassName('agenda-body')[0] as HTMLElement;
    if (container && calendar) {
      if (this.boolShowDailyEvent) {
        container.style.height = maxContainerSize > 95 ? '94px' : '104px';
        calendar.style.height = 'calc(100vh - 210px)';
        this.boolShowDailyEvent = false;
      }
      else {
        container.style.height = `${maxContainerSize + 10}px`;
        calendar.style.height = `calc(100vh - ${maxContainerSize + 131}px)`;
        this.boolShowDailyEvent = true;
      }
    }
    setTimeout(() => {
      this.isUpdate = false;
    }, 500);
  }

  public EmitEvent(event: AgendaEvent): void {
    this.isUpdate = true;
    if (event.isReadable || event.isUpdatable) {
      this.openEvent.emit(event);
    }
    setTimeout(() => {
      this.isUpdate = false;
    }, 500);
  }

  public OpenModal(daysToAdd: number, hoursToAdd: number): void {
    setTimeout(() => {
      if (!this.isUpdate) {
        const date: Date = this.qdate.ToDate(this.model.listCalendars[0].body.startDate) as Date;
        date.setDate(date.getDate() + daysToAdd);
        date.setHours(hoursToAdd);
        this.newEvent.emit(this.qdate.FromDateTime(date));
      }
    }, 0)
  }

  //#region drag & drop
  public allowDrop(ev: any, icol: number, irow: number, mode: string): void {
    if (this.dragMode === 'month' || this.dragMode === mode) {
      this.hoverDivMode = mode;
      this.dragRowId = irow;
      this.dragColId = icol;
      ev.preventDefault();
    }
  }
  public DisableDrop(ev: any): void {
    ev.stopPropagation();
  }

  public DragEnd(): void {
    this.dragStart = false;
  }

  public dragEvent(event: AgendaEvent, mode: string): void {
    this.dragStart = true;
    this.elementDragged = event;
    this.dragMode = mode;
  }
  public onDrop(e: any, dayIndex: number, heure: number): void {
    //#region construction du model
    const model: AgendaModelV3 = JSON.parse(JSON.stringify(this.model));
    model.Mode = 'UPDATE_DATE';
    model.selectedEvent = new SelectedEvent();
    model.selectedEvent.pEvent = this.elementDragged;
    let startDate: Date | null = this.qdate.ToDate(this.model.listCalendars[0].body.startDate);
    if (startDate) {
      startDate.setDate(startDate.getDate() + dayIndex);
      if (heure > -1) {
        startDate.setHours(heure);
        // startDate.setMinutes(0);
      }
    }
    model.selectedEvent.pEvent.endDate = JSON.parse(JSON.stringify(model.selectedEvent.pEvent.startDate));

    model.selectedEvent.pEvent.startDate = this.qdate.FromDateTime(startDate);
    if (heure < 0) {
      model.selectedEvent.pEvent.startDate.heures = '';
    }
    model.selectedEvent.pEvent.startDate.minutes = '';
    //#endregion
    if (this.elementDragged.isUpdatable) {
      this.loading.emit(true);
      this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, model).subscribe(
        (result: AgendaModelV3) => {
          this.loading.emit(false);
          if (result.Mode) {
            this.model = result;
          }
          this.modelChange.emit(this.model);
          setTimeout(() => { this.SetBeginAgenda(); }, 0);

        })
    } else {
      this.toastService.showAlertToast('vous ne disposez pas des droits nécessaires');
    }
  }


  public trackWeeklyCols(index: number, item: AgendaCol) {
    return item.id;
  }
  public trackWeeklyEvents(index: number, item: AgendaEvent) {
    return item.ident;
  }
  public trackDailyRows(index: number, item: AgendaRow) {
    return item.id;
  }
  public trackDailyCols(index: number, item: AgendaCol) {
    return item.id;
  }
  public trackDailyEvents(index: number, item: AgendaEvent) {
    return item.ident;
  }

  // #endregion

  //scroll dans le corps de l'agenda pour le positionner à la date du premier event (ou la valeur par défaut si aucun event < a la valeur par defaut)
  private SetBeginAgenda(value: boolean = true): void {
    if (value) {
      let i = setInterval(() => {
        if (this.model) {
          const beginAgenda: number = this.model.BeginWorkAgenda || this.model.BeginWorkAgenda == 0 ? this.model.BeginWorkAgenda : 5;
          const scroolWeek: any = document.getElementsByClassName('agenda-body');
          if (scroolWeek && scroolWeek.length > 0) {
            scroolWeek[0].scrollTop = (document.getElementsByClassName('agenda-body')[0].scrollHeight / 24 * beginAgenda) - 7;
          }
          clearInterval(i);
        }
      }, 10);

    }
    this.refreshDataChange.emit(false);
  }
}
